import initialState from './initialState';
import { types } from '../actions/budgetActions';

export default function budgetApplicationDetailsReducer(state = initialState.budgetApplications, action) {
  switch (action.type) {
    case types.GET_BUDGET_APPLICATION_DETAILS: {
      return {
        fetching: true,
      };
    }
    case types.GET_BUDGET_APPLICATION_DETAILS_FAILURE: {
      return {
        fetching: false,
      };
    }
    case types.GET_BUDGET_APPLICATION_DETAILS_SUCCESS: {
      return {
        fetching: false,
        data: action.data,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/budgetApplicationDetailsReducer.js